import { selectLowRateMortgage } from './selectLowRateMortgage';
import { ILowRateMortgagePromo } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectLowRateMortgagePromos = (state: IApplicationState): ILowRateMortgagePromo[] => {
  const lowRateMortgage = selectLowRateMortgage(state);

  return lowRateMortgage.promos;
};
